var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-view"}},[_c('nav-component'),_c('v-container',[_c('v-row',[_c('v-col',[_c('highscore'),_c('br'),_c('friends')],1),_c('v-col',[_c('about-user'),_c('br'),_c('your-scores')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }